import React, { 
    useState, 
    useEffect,
    useCallback } from 'react';
import {
    Button,
    Form,
    Input,
    Select,
    notification,
    Result
} from 'antd';
import MaskedInput from "antd-mask-input";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import axios from 'axios';
import {
    CheckCircleOutlined,
    CloseCircleOutlined
} from '@ant-design/icons';

function BusinessContactForm() {
    
    const [firstNameValidSuffix, setFirstNameValidSuffix] = useState(<></>);
    const [firstNameValid, setFirstNameValid] = useState(false);
    const [firstName, setFirstName] = useState('');

    const [lastNameValidSuffix, setLastNameValidSuffix] = useState(<></>);
    const [LastNameValid, setLastNameValid] = useState(false);
    const [lastName, setLastName] = useState('');

    const [companyNameValidSuffix, setCompanyNameValidSuffix] = useState(<></>);
    const [companyNameValid, setCompanyNameValid] = useState(false);
    const [companyName, setCompanyName] = useState('');

    const [emailValidSuffix, setEmailValidSuffix] = useState(<></>);
    const [emailValid, setEmailValid] = useState(false);
    const [email, setEmail] = useState('');

    const [phoneNumberValidSuffix, setPhoneNumberValidSuffix] = useState(<></>);
    const [phoneNumberValid, setPhoneNumberValid] = useState(false);
    const [phone, setPhone] = useState('');

    const [addressSuggestionList, setAddressSuggestionList] = useState(<></>);
    const [serviceAddress, setServiceAddress] = useState( headerVars.serviceAddress );
    const [serviceSelection, setServiceSelection] = useState( '' );

    const [formSubmitting, setFormSubmitting] = useState(false);
    const [showForm, setShowForm] = useState(true);
    const [submissionResult, setSubmissionResult] = useState(<></>);

    const { executeRecaptcha } = useGoogleReCaptcha();
    const [form] = Form.useForm();
    const siteDomain = headerVars.siteDomain;

    const [api, contextHolder] = notification.useNotification();

    //console.log("headerVars: ", headerVars);

    const handleOnInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        validateInput( currentVal, inputID );
    }

    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
          console.log('Execute recaptcha not yet available');
          return;
        }

        setFormSubmitting( true );

        const token = await executeRecaptcha('success');
        console.log("token: ", token);

        let form_data = new FormData;
        form_data.append('action', 'startca_handle_form_submissions');
        form_data.append('token', token);
        form_data.append('form', 'business_sales');
        form_data.append('first_name', firstName);
        form_data.append('last_name', lastName);
        form_data.append('email', email);
        form_data.append('phone', phone);
        form_data.append('service_address', serviceAddress);
        form_data.append('company_name', companyName);

        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            console.log( 'response:: ', response.data );
            setFormSubmitting( false );

            switch( response.data ) {
                case 'sent-successfully':
                openNotification('topLeft', 'sales');
                setShowForm( false );
                setSubmissionResult( 
                    <Result
                        status="success"
                        title="Your message was received sucessfully!"
                        subTitle="A member of our Sales team will be in touch with you shortly."
                        extra={[]}
                    />
                 );
                break;

                case 'failed-send':
                setShowForm( false );
                setSubmissionResult( 
                    <Result
                        status="error"
                        title="Submission failed!"
                        subTitle="There was a problem submitting your request. Please try again later."
                        extra={[]}
                    />
                 );
                break;
            }

        })
        .catch(function (error) {
            console.log(error);
            setSubmissionResult( 
                <Result
                    status="error"
                    title="Submission failed!"
                    subTitle="There was a problem submitting your request. Please try again later."
                    extra={[]}
                />
             );
        })
        .finally(function () {
            // always executed 
        });

    }, [executeRecaptcha,
        firstName,
        lastName,
        companyName,
        email,
        phone,
        serviceAddress,
        serviceSelection,
        setFormSubmitting
    ]);

    const openNotification = ( placement, formName ) => {
        switch( formName ) {
            case 'sales': 
            api.info({
                message: "Message Received!",
                description: "Thanks for reaching out A member of our sales team will be in contact soon.",
                placement,
            });
            break;
        }
    }

    const validateInput = ( currentVal, inputId ) => {
        let isValid = true;
        let validationSuffix = <></>;

        switch( inputId ) {
            case 'sales-form-first-name': 
                if( currentVal.length < 2 ){ 
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerName = isValid ? currentVal : '';

                setFirstNameValid( isValid );
                setFirstName( customerName );
                setFirstNameValidSuffix( validationSuffix );

                //console.log("firstName: ", firstName);
                
                if( !isValid ) { }
            break;

            case 'sales-form-last-name': 
                if( currentVal.length < 2 ){
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerLastName = isValid ? currentVal : '';

                setLastName( customerLastName );
                setLastNameValidSuffix( validationSuffix );
                setLastNameValid( isValid );

                if( !isValid ) { }
            break;

            case 'sales-form-phone-number': 
                //console.log( "currentVal:: ", currentVal );
                if( !currentVal.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im) ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerPhone = isValid ? currentVal : '';

                setPhone( currentVal );
                setPhoneNumberValidSuffix( validationSuffix );
                setPhoneNumberValid( isValid );

                if( !isValid ) { }
            break;

            case 'contact-info-email': 
                if( !currentVal.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerEmail = isValid ? currentVal : '';

                setEmail( customerEmail );
                setEmailValidSuffix( validationSuffix );
                setEmailValid( isValid );

                if( !isValid ) { }
            break;

            case 'sales-form-company-name': 
                setCompanyName( currentVal );
            break;
        }
    }

    const handleOnAddressInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        let form_data = new FormData;
        form_data.append('headers', {"Authorization": "Bearer "+headerVars.startAPIKey});

        if( currentVal.length > 6 ) {
            axios
            .get(headerVars.startAPIAddress+"/address/validate_telus?fullAddress="+currentVal, {headers:{"Authorization": "Bearer "+headerVars.startAPIKey}})
            .then(function(response){
                let suggestions = response.data.body.suggestions;
                //console.log('suggestions: ', suggestions);

                if(suggestions.length){
                    listAddressSugestions( suggestions ); 
                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                // always executed 
            }); 
        }
    }

    const listAddressSugestions = ( suggestions, lookupType ) => {
        let suggestionListItems = suggestions.map( suggestion => {
            let suggestionText = suggestion.text.replace(', CAN', '');
            return(
                <li id={suggestion.magicKey} className='address-suggestion-item' onClick={() => handleSuggestionClick( suggestionText, lookupType ) }>
                    { suggestionText + ". " }
                </li>
            );
        } );

        setAddressSuggestionList( <ul>{ suggestionListItems }</ul> );
    }

    const handleSuggestionClick = ( suggestionText, lookupType ) => {
        //console.log("suggestionText:: ", suggestionText);

        setServiceAddress( suggestionText );
        setAddressSuggestionList(<></>);
        form.setFieldsValue({ "service-address": suggestionText});
    }

    const handleChangeServiceSelection = ( value ) => {
        setServiceSelection( value );
    }

    return (
        <div className=''>
            <div className='react-contact-form'>
                <Form 
                    form={ form } 
                    style={{ 'display': ( showForm  ) ? 'block' : 'none' }}
                > 
                    <div className="form-column-row">
                        <Form.Item
                            label="First name"
                            className="form-item-left-column"
                            labelCol={{ span: 24 }}
                            name="firstname"
                            rules={[
                                {
                                required: true,
                                message: 'Please input your first name!',
                                },
                            ]}
                        >
                            <Input
                                id="sales-form-first-name"
                                suffix={ firstNameValidSuffix }
                                onChange={handleOnInputChange}
                                defaultValue={ firstName }
                            />
                        </Form.Item>
                        <Form.Item
                            label="Last name"
                            labelCol={{ span: 24 }}
                            name="lastname"
                            rules={[
                                {
                                required: true,
                                message: 'Please input your last name!',
                                },
                            ]}
                        >
                            <Input
                                id="sales-form-last-name"
                                suffix={ lastNameValidSuffix }
                                onChange={handleOnInputChange}
                                defaultValue={ lastName }
                            />
                        </Form.Item>
                    </div>
                    <div className="form-column-row">
                        <Form.Item
                            label="Phone number"
                            labelCol={{ span: 24 }}
                            name="phonenumber"
                            className="form-item-left-column"
                            rules={[
                                {
                                required: true,
                                message: 'Please input your phone number!',
                                },
                            ]}
                        >
                            <MaskedInput
                                id="sales-form-phone-number"
                                mask={'(000) 000-0000'}
                                suffix={ phoneNumberValidSuffix }
                                onChange={handleOnInputChange}
                                defaultValue={ phone }
                            />
                        </Form.Item>
                        <Form.Item
                            label="Email address"
                            name="emailaddress"
                            //style={{paddingRight:'1rem'}}
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                required: true,
                                message: 'Please input your email!',
                                },
                            ]}
                        >
                            <Input 
                                id="contact-info-email"
                                suffix={ emailValidSuffix }
                                onChange={handleOnInputChange}
                                defaultValue={ email }
                            />
                        </Form.Item>
                    </div>

                    <div className="form-column-row position-swap-for-mobile">
                        <Form.Item
                            label="Service address"
                            labelCol={{ span: 24 }}
                            name="service-address"
                            className="form-item-left-column address-item"
                            style={{width:'100%', marginBottom:'24px'}}
                            rules={[
                                {
                                required: false,
                                message: 'Please input your service address!',
                                },
                            ]}
                        >
                            <Input
                                id="service-address-input"
                                name="service-address-input"
                                onChange={handleOnAddressInputChange}
                                defaultValue={ serviceAddress }
                            />
                        </Form.Item>
                        <Form.Item
                            label="Company name"
                            labelCol={{ span: 24 }}
                            name="companyname"
                            className="company-name-item"
                            rules={[
                                {
                                required: false,
                                message: 'Please input your company name!',
                                },
                            ]}
                        >
                            <Input
                                id="sales-form-company-name"
                                suffix={ companyNameValidSuffix }
                                onChange={handleOnInputChange}
                                defaultValue={ companyName }
                            />
                        </Form.Item>
                    </div>
                    <div className="suggestion-list-container">
                        { addressSuggestionList }
                    </div>
                    <Button 
                        className='g-recaptcha business-form-button'
                        onClick={ handleReCaptchaVerify }
                        loading={ formSubmitting }
                        type="primary"
                        disabled={ ( firstNameValid && LastNameValid && emailValid ) ? false : true }
                    >Submit</Button>
                </Form>
                { submissionResult }
            </div>
            { contextHolder }
        </div>
    )
}

export default BusinessContactForm
